import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Loading } from "@/components/Bits";
import { DocumentList } from "@/components/DocumentList";
import { FileText } from "lucide-react";

export default function TenantDocuments() {
  const [docs, setDocs] = useState(null);
  useEffect(() => { api.get("/tenant/documents").then((r) => setDocs(r.data)); }, []);
  if (!docs) return <Loading />;

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight text-slate-900 mb-1">My documents</h1>
      <p className="text-sm text-slate-500 mb-7">Your signed lease, Section 8 paperwork and move-in checklist, in one place.</p>
      <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="tenant-documents">
        <div className="flex items-center gap-2 mb-4"><FileText className="h-5 w-5 text-primary" /><h2 className="font-display font-bold text-lg text-slate-900">Shared with you</h2></div>
        <DocumentList docs={docs} emptyText="Nothing here yet — your landlord hasn't shared any documents, and your move-in checklist will appear here once submitted." />
      </div>
    </div>
  );
}
